import { style } from '@vanilla-extract/css';
import { vars } from '@/shared/ui/theme';
import {
  authPanel,
  authContentContainer,
  authFormArea,
} from '@/shared/ui/templates/AuthScene/AuthScene.css';

export {
  stepFormContent,
  buttonGroup,
  errorBox,
  errorIcon,
  errorText,
} from '@/shared/ui/templates/AuthScene/AuthScene.css';

// ============================================
// REGISTER-ONLY: Panel overrides
// ============================================

export const registerPanel = style([
  authPanel,
  {
    height: '600px',
    display: 'flex',
    flexDirection: 'column' as const,
    overflow: 'hidden',
  },
]);

export const registerContentContainer = style([
  authContentContainer,
  {
    flex: 1,
    minHeight: 0,
  },
]);

export const registerFormArea = style([
  authFormArea,
  {
    flex: 1,
    overflow: 'auto',
    scrollbarGutter: 'stable',
  },
]);

// ============================================
// VERIFY STEP — 가입 확인 코드 (87bac89b)
// ============================================

/** 코드를 보낸 주소 — 사용자가 어느 메일함을 열어야 하는지 한눈에 */
export const verifyEmail = style({
  display: 'block',
  fontSize: vars.typography.fontSize.sm,
  fontWeight: vars.typography.fontWeight.semibold,
  color: vars.typography.textColor.primary,
  wordBreak: 'break-all',
});

/** 코드 안내 문장 — 만료 시간과 재전송 안내 */
export const verifyHint = style({
  margin: 0,
  fontSize: vars.typography.fontSize.xs,
  color: vars.typography.textColor.secondary,
  lineHeight: String(1.6),
});

// ============================================
// FIELD LABEL (for Select)
// ============================================

export const fieldLabel = style({
  display: 'block',
  fontSize: vars.typography.fontSize.xs,
  fontWeight: vars.typography.fontWeight.semibold,
  color: vars.typography.textColor.secondary,
  marginBottom: '6px',
  letterSpacing: vars.typography.letterSpacing.wide,
});
